import { createNodeDef } from "../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { createFunctionWithContext } from "./_code.helpers";

export const variableNodeDef = createNodeDef({
  type: "variable",
  displayName: "Variable",
  acceptsChildren: true,
  initialData: () => ({ value: "'hello world'" }),
  fields: [
    { type: DataFieldType.TEXT, format: "code", key: "value", label: "Value" },
  ],
  generate: async ({ node, context, children }) => {
    try {
      const functionCtx = context.copy();
      await children.withContext(functionCtx).generateValues();

      const fn = createFunctionWithContext(functionCtx, node.data.value);
      const result = fn();
      context.append({ name: node.name, nodeType: node.type, value: result });
    } catch (error) {
      context.append({
        name: node.name,
        nodeType: node.type,
        value: `Invalid value (${error})`,
      });
    }
  },
});
